import { defineStore, getActivePinia, } from 'pinia'
import fetch from '@/assets/js/src/util/fetch'
import { getDefaultHeaders, } from '@/assets/js/src/util/fetch/defaultHeaders'
import cookieManager from 'js-cookie'
import { COOKIE_LIKES, } from '@/assets/js/src/modules/like/_pinia/_constants'
import { checkResponse, handleException, paramsToQuery, } from '@/assets/js/src/util/apiTools'
import { useBibleStore, } from '@/assets/js/src/modules/bible/_pinia/bible'
import { useUserStore, } from '@/assets/js/src/modules/user/_pinia/user'
import { useAppUiStore, } from '@/assets/js/src/pinia/appUi'

const API_REST_LIKE_MULTIPLE = '/api/likes'
const API_REST_LIKE_MULTIPLE_DELETE = '/api/likes/delete'
const API_REST_LIKE = '/api/like'

export const useLikeStore = defineStore('like', {
    state: () => ({
        // Sort - Params
        reload: false,

        // Filter - Params
        books: [],

        // Content - Meta
        responseMeta: {},
        page: 1,
        limit: 20,

        // Content - List
        likes: [],
        verses: [],

        // Cache - Options
        mode: 'put',
    }),
    actions: {
        async getLikes ({ page, }) {
            let activePinia = getActivePinia()
            let bibleStore = useBibleStore(activePinia)
            let userStore = useUserStore(activePinia)

            page = page || 1

            try {
                // Api-Request senden
                let apiResponse = await fetch({
                    url: `${API_REST_LIKE_MULTIPLE}?${paramsToQuery({
                        filter: JSON.stringify({
                            books: this.books,
                            my: userStore.user.options.like.list.my,
                        }),
                        sort: userStore.user.options.like.list.sort,
                        page,
                        limit: this.limit,
                        abbr: bibleStore.firstSelectedBible,
                    })}`,
                    options: {
                        headers: getDefaultHeaders({}),
                    },
                })

                // Api-Response prüfen
                if (checkResponse(apiResponse)) {
                    throw new Error('Fehler in Api-Response')
                }

                const { likes, verses, ...responseMeta } = apiResponse.data

                this.page = page
                this.likes = likes
                this.verses = verses
                this.responseMeta = responseMeta
            } catch (e) {
                // Evtl. Fehler ausgeben
                handleException(e, true, false)
            }
        },
        async createLikes ({ canonicals,updateSidebar, }) {
            let activePinia = getActivePinia()
            let appUiStore = useAppUiStore(activePinia)

            // Send Request to store like on server
            let apiResponse = await fetch({
                url: API_REST_LIKE_MULTIPLE,
                options: {
                    method: 'POST',
                    body: JSON.stringify({ canonicals, }),
                    headers: getDefaultHeaders({}),
                },
                loading: false,
            })

            // Update Sidebar
            if(updateSidebar) {
                appUiStore
                    .setSidebarState({
                        reload: true,
                        provider: 'like',
                        mode: 'put', })
                    .finally(()=>{
                        appUiStore.resetSidebarState()
                    })
            }

            // Update Cookie
            if(canonicals.length) {
                let tmpLikes = JSON.parse(cookieManager.get(COOKIE_LIKES) || '[]')
                canonicals.forEach(canonical => {
                    tmpLikes.indexOf(canonical) === -1 && tmpLikes.push(canonical)
                })
                cookieManager.set(COOKIE_LIKES,JSON.stringify(tmpLikes))
            }

            return Array.isArray(apiResponse.data) ? apiResponse.data.map((like)=>like.id) : [ apiResponse.data.id, ]
        },
        async deleteLikes ({ ids,canonicals,updateSidebar, }) {
            let activePinia = getActivePinia()
            let appUiStore = useAppUiStore(activePinia)
            
            // Send silent Request to store like on server
            await fetch({
                url: API_REST_LIKE_MULTIPLE_DELETE,
                options: {
                    method: 'POST',
                    body: JSON.stringify({ ids, }),
                    headers: getDefaultHeaders({}),
                },
                loading: false,
            })

            // Update Sidebar
            if(updateSidebar) {
                appUiStore
                    .setSidebarState({
                        reload: true,
                        provider: 'like', })
                    .finally(()=>{
                        appUiStore.resetSidebarState()
                    })
            }

            // Update Cookie
            if(canonicals.length) {
                let tmpLikes = JSON.parse(cookieManager.get(COOKIE_LIKES) || '[]')
                canonicals.forEach(canonical => {
                    tmpLikes.splice(tmpLikes.indexOf(canonical), 1)
                })
                cookieManager.set(COOKIE_LIKES,JSON.stringify(tmpLikes))
            }
        },
        async deleteLike ({ id,canonical, }) {
            let activePinia = getActivePinia()
            let appUiStore = useAppUiStore(activePinia)

            try {
                // Send silent Request to store like on server
                let apiResponse = await fetch({
                    url: `${API_REST_LIKE}/${id}`,
                    options: {
                        method: 'DELETE',
                        headers: getDefaultHeaders({}),
                    },
                })

                // Api-Response prüfen
                if (checkResponse(apiResponse)) {
                    throw new Error('Fehler in Api-Response')
                }

                // Update Sidebar
                appUiStore
                    .setSidebarState({
                        reload: true,
                        provider: 'like', })
                    .finally(()=>{
                        appUiStore.resetSidebarState()
                    })

                // Update Cookie
                if(canonical) {
                    let tmpLikes = JSON.parse(cookieManager.get(COOKIE_LIKES) || '[]')
                    tmpLikes.splice(tmpLikes.indexOf(canonical), 1)
                    cookieManager.set(COOKIE_LIKES,JSON.stringify(tmpLikes))
                }

                // Reload
                this.reload = true
            } catch (e) {
                // Evtl. Fehler ausgeben
                handleException(e, false, false)
            }

        },
    },
})
